// @flow

import * as React from 'react';
import Box from 'sail/Box';
import Toggle, {ToggleItem} from 'sail/Toggle';
import {usePrefs} from 'docs/data';
import {useActivePage} from 'docs/hooks';
import {defineMessages, useIntl} from 'react-intl';

const PREF_KEY = 'pricing-style';

const messages = defineMessages({
  exclusivePricing: {
    id: 'docsApp.integrationGuidePageSelector.exclusivePricing',
    description: 'Label for a tab about exclusive pricing',
    defaultMessage: 'Exclusive pricing',
  },
  inclusivePricing: {
    id: 'docsApp.integrationGuidePageSelector.inclusivePricing',
    description: 'Label for a tab about inclusive pricing',
    defaultMessage: 'Inclusive pricing',
  },
});

export const IntegrationGuidePageSelector = () => {
  const {setPref} = usePrefs();
  const activePage = useActivePage();
  const intl = useIntl();

  const pricingStyles = [
    {id: 'exclusive', title: intl.formatMessage(messages.exclusivePricing)},
    {id: 'inclusive', title: intl.formatMessage(messages.inclusivePricing)},
  ];

  return (
    <Box>
      <Box margin={{bottom: 24}}>
        <Toggle type="radio" size="large">
          {pricingStyles.map((pricingStyle) => (
            <ToggleItem
              key={pricingStyle.id}
              label={pricingStyle.title}
              checked={pricingStyle.id === activePage.prefs[PREF_KEY]}
              onChange={() => setPref(PREF_KEY, pricingStyle.id)}
            />
          ))}
        </Toggle>
      </Box>
    </Box>
  );
};
